import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=2b85d43b&scoped=true"
import script from "./InputSelect.vue?vue&type=script&lang=ts"
export * from "./InputSelect.vue?vue&type=script&lang=ts"
import style0 from "./InputSelect.vue?vue&type=style&index=0&id=2b85d43b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85d43b",
  null
  
)

export default component.exports